/**
 * Five Elephant — PDP/card variant price sync
 * Prices come only from each product's Shopify variants (never hardcoded).
 *
 * Sticky size selection + stamped data-variant-id so 1kg never falls back
 * to 250g, and ReCharge/BSS cannot leave the wrong size price on screen.
 */
(function () {
  'use strict';

  (function injectPriceAntiflicker() {
    if (document.getElementById('fe-price-antiflicker')) return;
    var style = document.createElement('style');
    style.id = 'fe-price-antiflicker';
    style.textContent =
      '.custom-product__price .bss-b2b-product-vat,' +
      '.custom-product__price .bss-b2b-product-vat-price-no-vat,' +
      '.custom-product__price .bss-b2b-product-vat-price-has-vat,' +
      '.custom-product__price .recharge-inner-most-price,' +
      '.custom-product__price .recharge-most-price{display:none!important}';
    (document.head || document.documentElement).appendChild(style);
  })();

  var selectedVariantId = null;
  var selectedSizeToken = null;
  var lastVariant = null;
  var priceObserver = null;
  var painting = false;

  function sizeToken(v) {
    var s = String(v || '')
      .toLowerCase()
      .replace(/\s+/g, '');
    // Match kg first so "1kg" never collapses to a bare "g" token.
    var m = s.match(/(\d+(?:[.,]\d+)?)kg\b/) || s.match(/(\d+(?:[.,]\d+)?)g\b/);
    if (!m) {
      m = s.match(/(\d+(?:[.,]\d+)?)kg/) || s.match(/(\d+(?:[.,]\d+)?)g/);
    }
    if (!m) return '';
    var num = parseFloat(String(m[1]).replace(',', '.'));
    if (isNaN(num)) return '';
    var unit = String(m[0]).indexOf('kg') !== -1 ? 'kg' : 'g';
    if (unit === 'g' && num >= 1000 && num % 1000 === 0) {
      num = num / 1000;
      unit = 'kg';
    }
    var n = String(num).replace(/\.0+$/, '');
    return n + unit;
  }

  function productJson(form) {
    var root =
      (form && form.closest('.shopify-section')) ||
      (form && form.closest('[data-section-type]')) ||
      document;
    var el =
      (root.querySelector && root.querySelector('[data-product-json]')) ||
      document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function taxRate() {
    var r = window.FiveElephant && Number(FiveElephant.tax_rate);
    if (!isNaN(r) && r > 0) return r;
    return 1.07;
  }

  function roundCents(c) {
    c = Math.round(Number(c) || 0);
    var m = ((c % 100) + 100) % 100;
    if (m === 1) return c - 1;
    if (m === 99) return c + 1;
    return c;
  }

  function withTax(cents) {
    return roundCents(Math.round(Number(cents) * taxRate()));
  }

  function plainMoney(cents) {
    return '€' + (Number(cents) / 100).toFixed(2);
  }

  function findVariantById(product, id) {
    if (!product || !product.variants || id == null || id === '') return null;
    var i;
    for (i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  function variantSizeToken(variant) {
    if (!variant) return '';
    return (
      sizeToken(variant.title) ||
      sizeToken(variant.option1) ||
      sizeToken((variant.options && variant.options[0]) || '')
    );
  }

  function selectedOptionsFromForm(form) {
    var opts = { option1: '', option2: '', option3: '' };
    if (!form) return opts;
    form
      .querySelectorAll(
        '.custom-variant-input:checked, input[data-single-option-selector][type="radio"]:checked, select[data-single-option-selector]'
      )
      .forEach(function (el) {
        var idx = el.getAttribute('data-index');
        if (!idx || !opts.hasOwnProperty(idx)) return;
        var val = String(el.value || '');
        if (val) opts[idx] = val;
      });
    return opts;
  }

  function hasStyleOption(opts) {
    return !!(opts && opts.option2);
  }

  function findVariantByOptions(product, opts) {
    if (!product || !product.variants || !opts) return null;
    var i;
    var v;
    for (i = 0; i < product.variants.length; i++) {
      v = product.variants[i];
      if (opts.option1 && String(v.option1) !== opts.option1) continue;
      if (opts.option2 && String(v.option2) !== opts.option2) continue;
      if (opts.option3 && String(v.option3) !== opts.option3) continue;
      return v;
    }
    return null;
  }

  function findBySizeToken(product, token, style) {
    if (!product || !product.variants || !token) return null;
    var matches = [];
    var i;
    for (i = 0; i < product.variants.length; i++) {
      if (variantSizeToken(product.variants[i]) === token) matches.push(product.variants[i]);
    }
    if (!matches.length) return null;
    if (style) {
      var sl = String(style).toLowerCase();
      for (i = 0; i < matches.length; i++) {
        if (String(matches[i].option2 || '').toLowerCase() === sl) return matches[i];
      }
    }
    if (matches.length === 1) return matches[0];
    for (i = 0; i < matches.length; i++) {
      var t = String(matches[i].title || '').toLowerCase();
      if (t.indexOf('tin') === -1 && t.indexOf('sample') === -1 && t.indexOf('probe') === -1) {
        return matches[i];
      }
    }
    return matches[0];
  }

  function remapStaleRechargeMap(product) {
    try {
      if (!window.ReCharge || !product || !product.variants) return;
      (ReCharge.products || []).forEach(function (p) {
        if (!p || String(p.id) !== String(product.id) || !p.variant_to_duplicate) return;
        var map = p.variant_to_duplicate;
        var hasCurrent = product.variants.some(function (v) {
          return map[v.id] || map[String(v.id)];
        });
        if (hasCurrent) return;
        var legacy = {
          '2x250g|filter': '40548945756340',
          '2x250g|espresso': '40548945789108',
          '3x250g|filter': '40548945821876',
          '3x250g|espresso': '40548945854644',
        };
        function subSizeKey(v) {
          var s = String((v && (v.option1 || v.title)) || '')
            .toLowerCase()
            .replace(/\s+/g, '');
          if (s.indexOf('3x250') !== -1) return '3x250g';
          if (s.indexOf('2x250') !== -1) return '2x250g';
          return sizeToken(s);
        }
        product.variants.forEach(function (v) {
          var size = subSizeKey(v);
          var style = String(v.option2 || '').toLowerCase();
          var oldId = legacy[size + '|' + style];
          var hidden = (oldId && (map[oldId] || map[Number(oldId)])) || null;
          if (hidden) {
            map[v.id] = hidden;
            map[String(v.id)] = hidden;
          }
        });
      });
    } catch (e) {}
  }

  function findVariant(product, checked, opts) {
    if (!checked) return null;
    opts = opts || {};

    if (hasStyleOption(opts)) {
      var byOpts = findVariantByOptions(product, opts);
      if (byOpts) return byOpts;
    }

    // Sticky user pick wins (prevents ReCharge/:checked races flipping back to 250g)
    if (selectedVariantId && !hasStyleOption(opts)) {
      var sticky = findVariantById(product, selectedVariantId);
      if (sticky) {
        if (!selectedSizeToken || !variantSizeToken(sticky) || variantSizeToken(sticky) === selectedSizeToken) {
          return sticky;
        }
      }
      if (selectedSizeToken) {
        var byTok = findBySizeToken(product, selectedSizeToken, opts.option2);
        if (byTok) return byTok;
      }
    }

    var stamped = checked.getAttribute('data-variant-id');
    if (stamped && !hasStyleOption(opts)) {
      var byStamp = findVariantById(product, stamped);
      if (byStamp) return byStamp;
      if (checked.getAttribute('data-variant-price') != null) {
        return {
          id: stamped,
          price: Number(checked.getAttribute('data-variant-price')),
          title: checked.value,
          option1: checked.value,
          options: [checked.value],
        };
      }
    }

    if (!product || !product.variants) return null;

    var val = String(checked.value || '');
    var i;
    for (i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (
        String(v.option1) === val ||
        String(v.title) === val ||
        (v.options && String(v.options[0]) === val)
      ) {
        return v;
      }
    }

    return findBySizeToken(product, selectedSizeToken || sizeToken(val), opts.option2);
  }

  function mainForm() {
    return (
      document.querySelector('form.product-form:not(.cart-bar__form)') ||
      document.querySelector('form.product-form')
    );
  }

  function killRechargePricing() {
    try {
      if (!window.ReCharge) return;
      if (ReCharge.options) ReCharge.options.update_pricing = false;
      (ReCharge.products || []).forEach(function (p) {
        if (p && p.options) p.options.update_pricing = false;
      });
      if (ReCharge._updateProductPrice) ReCharge._updateProductPrice = function () {};
      if (ReCharge._updatePricing) ReCharge._updatePricing = function () {};
    } catch (e) {}
  }

  function setIds(variantId, variant) {
    var id = String(variantId);
    selectedVariantId = id;
    document.querySelectorAll('form.product-form').forEach(function (form) {
      form.querySelectorAll('select[name="id"], select[data-product-select]').forEach(function (sel) {
        if (sel.getAttribute('name') === 'id') sel.setAttribute('data-fe-was-name', 'id');
        sel.removeAttribute('name');
        var i;
        for (i = 0; i < sel.options.length; i++) {
          if (String(sel.options[i].value) === id) {
            sel.selectedIndex = i;
            try {
              sel.value = id;
            } catch (e) {}
            break;
          }
        }
      });

      var hidden = form.querySelector('input[data-fe-variant-id]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'id';
        hidden.setAttribute('data-fe-variant-id', '1');
        form.appendChild(hidden);
      }
      hidden.name = 'id';
      hidden.value = id;

      if (variant) {
        form.querySelectorAll('select[data-single-option-selector]').forEach(function (sel) {
          var idx = sel.getAttribute('data-index');
          var want = '';
          if (idx === 'option1') want = String(variant.option1 || '');
          else if (idx === 'option2') want = String(variant.option2 || '');
          else if (idx === 'option3') want = String(variant.option3 || '');
          else want = String(variant.option1 || variant.title || '');
          var wantTok = sizeToken(want);
          var j;
          for (j = 0; j < sel.options.length; j++) {
            var ov = String(sel.options[j].value);
            if (ov === want || (wantTok && sizeToken(ov) === wantTok)) {
              sel.selectedIndex = j;
              try {
                sel.value = ov;
              } catch (e) {}
              break;
            }
          }
        });
      }
    });
  }

  function setPriceText(el, plain) {
    if (!el) return;
    el.classList.remove('recharge-inner-most-price', 'recharge-most-price');
    if ((el.textContent || '').trim() !== plain) el.textContent = plain;
  }

  function paintPrice(variant) {
    if (!variant || variant.price == null || isNaN(Number(variant.price))) return;
    painting = true;
    if (priceObserver) priceObserver.disconnect();
    lastVariant = variant;
    killRechargePricing();

    var netCents = Number(variant.price);
    var grossCents = withTax(netCents);
    var plain = plainMoney(grossCents);
    var netPlain = plainMoney(netCents);

    document
      .querySelectorAll(
        [
          '.custom-product__price [data-product-price]',
          '.custom-product__price .recharge-inner-most-price',
          '.cart-bar__product__price [data-product-price]',
          '#cart-bar [data-product-price]',
          'form.product-form .recharge-inner-most-price',
        ].join(', ')
      )
      .forEach(function (el) {
        setPriceText(el, plain);
        el.setAttribute('data-fe-price', (grossCents / 100).toFixed(2));
      });

    document.querySelectorAll('.custom-product__price .bss-b2b-product-vat-price-has-vat').forEach(function (el) {
      // Keep only the numeric price (no "incl VAT" label).
      var next = plain;
      if ((el.textContent || '').trim() !== next) el.textContent = next;
    });
    document.querySelectorAll('.custom-product__price .bss-b2b-product-vat-price-no-vat').forEach(function (el) {
      // Keep only the numeric price (no "exc VAT" label).
      var next = netPlain;
      if ((el.textContent || '').trim() !== next) el.textContent = next;
    });

    document
      .querySelectorAll(
        '.custom-product__price [bss-b2b-variant-id], .custom-product__price [bss-b2b-product-price], [bss-b2b-featured-product]'
      )
      .forEach(function (el) {
        el.setAttribute('bss-b2b-variant-id', String(variant.id));
      });
    document.querySelectorAll('.custom-product__price .bss-b2b-product-vat').forEach(function (el) {
      el.setAttribute('data-selected-variant-id', String(variant.id));
    });

    var rc = document.getElementById('rc_price_onetime');
    if (rc) setPriceText(rc, netPlain);

    painting = false;
    watchPrice();
  }

  function watchPrice() {
    var wrap = document.querySelector('.custom-product__price');
    if (!wrap) return;
    if (priceObserver) priceObserver.disconnect();
    priceObserver = new MutationObserver(function () {
      if (painting || !lastVariant) return;
      painting = true;
      var expected = plainMoney(withTax(lastVariant.price));
      var expectedNet = plainMoney(lastVariant.price);
      wrap
        .querySelectorAll('[data-product-price], .recharge-inner-most-price')
        .forEach(function (el) {
          setPriceText(el, expected);
        });
      var rc = document.getElementById('rc_price_onetime');
      if (rc) setPriceText(rc, expectedNet);
      painting = false;
    });
    priceObserver.observe(wrap, { childList: true, subtree: true, characterData: true });
  }

  function checkedRadio(form) {
    if (!form) return null;
    var opts = selectedOptionsFromForm(form);
    if (hasStyleOption(opts)) {
      return (
        form.querySelector('.custom-variant-input[data-index="option2"]:checked') ||
        form.querySelector('input[data-single-option-selector][data-index="option2"]:checked') ||
        form.querySelector('.custom-variant-input:checked') ||
        form.querySelector('input[data-single-option-selector][type="radio"]:checked')
      );
    }
    if (selectedVariantId) {
      var byId = form.querySelector(
        '.custom-variant-input[data-variant-id="' +
          selectedVariantId +
          '"], input[data-single-option-selector][data-variant-id="' +
          selectedVariantId +
          '"]'
      );
      if (byId) return byId;
    }
    if (selectedSizeToken) {
      var radios = form.querySelectorAll(
        '.custom-variant-input, input[data-single-option-selector][type="radio"]'
      );
      var i;
      for (i = 0; i < radios.length; i++) {
        if (sizeToken(radios[i].value) === selectedSizeToken) return radios[i];
      }
    }
    return (
      form.querySelector('.custom-variant-input:checked') ||
      form.querySelector('input[data-single-option-selector][type="radio"]:checked')
    );
  }

  function rememberSelection(radio) {
    if (!radio) return;
    var idx = radio.getAttribute('data-index') || '';
    var stamped = radio.getAttribute('data-variant-id');
    if (stamped && idx !== 'option2' && idx !== 'option3') {
      selectedVariantId = String(stamped);
    }
    var tok = sizeToken(radio.value);
    if (tok) selectedSizeToken = tok;
    try {
      radio.checked = true;
    } catch (e) {}
  }

  function syncFromMain() {
    var form = mainForm();
    if (!form) return false;
    var product = productJson(form);
    remapStaleRechargeMap(product);
    var opts = selectedOptionsFromForm(form);
    var checked = checkedRadio(form);
    if (!checked && !hasStyleOption(opts)) return false;
    if (checked) rememberSelection(checked);
    var variant = hasStyleOption(opts)
      ? findVariantByOptions(product, opts) || (checked && findVariant(product, checked, opts))
      : checked && findVariant(product, checked, opts);
    if (!variant || variant.id == null || variant.price == null) return false;
    if (selectedSizeToken && !hasStyleOption(opts)) {
      var vt = variantSizeToken(variant);
      if (vt && vt !== selectedSizeToken) {
        var corrected = findBySizeToken(product, selectedSizeToken, opts.option2);
        if (!corrected) return false;
        variant = corrected;
      }
    }
    setIds(variant.id, variant);
    paintPrice(variant);
    return true;
  }

  function scheduleSync() {
    syncFromMain();
    [0, 50, 150, 400, 900, 1800].forEach(function (ms) {
      setTimeout(syncFromMain, ms);
    });
  }

  function onSizeEvent(e) {
    var t = e.target;
    if (!t) return;
    var radio =
      (t.matches &&
        t.matches('.custom-variant-input, input[data-single-option-selector][type="radio"]') &&
        t) ||
      (t.closest &&
        t.closest('.custom-variant-input, input[data-single-option-selector][type="radio"]'));
    if (!radio) {
      var label =
        t.closest &&
        t.closest('.custom-variant__button-label, .variant__button-label, .variant-field label');
      if (label) {
        var forId = label.getAttribute('for');
        radio = forId ? document.getElementById(forId) : null;
        if (!radio && label.control) radio = label.control;
      }
    }
    if (!radio) return;
    rememberSelection(radio);
    scheduleSync();
  }

  function applyCard(pill) {
    var card = pill.closest('.product-item, .fe-product-card, [data-grid-item]');
    if (!card) return;
    var priceHtml = pill.getAttribute('data-price-html');
    var variantId = pill.getAttribute('data-variant-id');
    if (!priceHtml || !variantId) return;
    var group = pill.closest('[data-fe-card-sizes]') || card;
    group.querySelectorAll('[data-fe-card-size]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === pill);
      btn.setAttribute('aria-pressed', btn === pill ? 'true' : 'false');
    });
    group.setAttribute('data-selected-variant-id', variantId);
    var priceEl =
      card.querySelector('[data-fe-card-price]') ||
      card.querySelector('.product-item__price .new-price');
    if (priceEl) priceEl.innerHTML = priceHtml;
    card.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (inp) {
      inp.value = variantId;
    });
  }

  document.addEventListener('click', onSizeEvent, true);
  document.addEventListener('change', onSizeEvent, true);
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (
        t.matches('[name="selling_plan"]') ||
        t.matches('[name="purchase_type"]') ||
        t.matches('.rc_radio') ||
        t.id === 'rc_shipping_interval_frequency'
      ) {
        scheduleSync();
      }
    },
    true
  );
  document.addEventListener(
    'click',
    function (e) {
      var pill = e.target.closest && e.target.closest('[data-fe-card-size]');
      if (!pill) return;
      e.preventDefault();
      e.stopPropagation();
      applyCard(pill);
    },
    true
  );

  function boot() {
    killRechargePricing();
    var form = mainForm();
    var checked = form && checkedRadio(form);
    if (checked) rememberSelection(checked);
    syncFromMain();
    document.querySelectorAll('[data-fe-card-sizes]').forEach(function (g) {
      var a =
        g.querySelector('[data-fe-card-size].is-active') ||
        g.querySelector('[data-fe-card-size]');
      if (a) applyCard(a);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('load', function () {
    boot();
    setTimeout(boot, 300);
    setTimeout(boot, 1200);
  });

  setInterval(function () {
    killRechargePricing();
    syncFromMain();
  }, 600);
})();
